<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom:0;">About the Author</h1>
<div class="figure" style="text-align: center;">
<img alt="" src="media/file0.jpg" style="width:2.57049in;height:2.97697in"/>
<p class="caption">C:\Users\Admin\Contacts\Desktop\IMG_1037.jpg</p>
</div><br/>
<p>Born in Bangladesh, Shukdeb Sen moved to Calcutta (now Kolkata), India. He then immigrated to U.S.A. and has spent over a thirty-year career in teaching, research, and mentoring undergraduate students at various colleges and universities in South. <em>If Life Was a Dream</em> is his first poetry book. He has published a non-fiction book titled, <em>Black Education in White America.</em> He authored over thirty research articles in scientific journals and he currently lives in Florida, U.S.A.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?26da4ce6